import { useEffect, useRef } from "react";
import Autenticar from "@/features/Usuario/Autenticar/autenticar";
import { useDispatch, useSelector } from "react-redux";
import { GET_USER_TAB, SET_USER_TAB, SET_USER_STEP, SET_MODAL } from "@/store/slices/appSlice";
import Cadastrar from "@/features/Usuario/Cadastrar/cadastrar";
import Recuperar from "@/features/Usuario/Recuperar/recuperar";
import ContinuarRedesSociais from "@/features/Usuario/ContinuarRedesSociais";
import Autenticado from "@/features/Usuario/Autenticado/autenticado";
import { useCookies } from 'react-cookie';
import { SET_USER, GET_USER } from "@/store/slices/userSlice";
import UserAlert from "@/components/alert/userAlert";
import { SET_LEAD_DOCUMENTO, SET_LEAD_EMAIL, SET_LEAD_NOME } from "@/store/slices/leadSlice";
import { isValidCookie } from "@/interfaces/CookieOespInfo";
import { setAuthMethodIfDefault } from "@/utils/AuthMethod";

export default function Usuario() {
    const dispatch = useDispatch();
    const [cookies] = useCookies();
    const currentTab = useSelector(GET_USER_TAB)
    let effectiveTab = currentTab;
    const USER = useSelector(GET_USER);
    const isAssinante = USER.assinante || (cookies.OESP_INFO && cookies.OESP_INFO.produtos && cookies.OESP_INFO.produtos.length > 0 && cookies.OESP_INFO.produtos.indexOf('Not_') > -1);
    let isLoggedIn = false;
    let hasValidTelefone = false;
    const hasAutoAdvanced = useRef(false);

    if (cookies.hasOwnProperty('OESP_INFO')) {
        const oesp_info = {
            id: cookies.OESP_INFO.id,
            email: cookies.OESP_INFO.email,
            nome: cookies.OESP_INFO.nome,
            sobre_nome: cookies.OESP_INFO.sobre_nome,
            cpf: cookies.OESP_INFO.cpf,
            telefone: cookies.OESP_INFO.telefone
        }
        if (isValidCookie(oesp_info)) {
            isLoggedIn = true;
            hasValidTelefone = !!(oesp_info.telefone && oesp_info.telefone.trim().length >= 8)
            setAuthMethodIfDefault('logado_sessao_ativa')
            if (currentTab !== 1) {
                dispatch(SET_USER_TAB(2))
                effectiveTab = 2;
            }
            dispatch(SET_LEAD_EMAIL(cookies.OESP_INFO.email))
            dispatch(SET_LEAD_NOME(`${cookies.OESP_INFO.nome} ${cookies.OESP_INFO.sobre_nome ? cookies.OESP_INFO.sobre_nome : ''}`))
            dispatch(SET_LEAD_DOCUMENTO(cookies.OESP_INFO.cpf))
            dispatch(SET_USER({
                ...cookies.OESP_INFO,
                id_usuario: cookies.OESP_INFO.id
            }))
        }
    }

    useEffect(() => {
      if (isLoggedIn && hasValidTelefone && !hasAutoAdvanced.current) {
        hasAutoAdvanced.current = true
        dispatch(SET_USER_STEP(2))
      }
    }, [isLoggedIn, hasValidTelefone, dispatch])

    useEffect(() => {
      if (effectiveTab === 2 && isAssinante) {
        dispatch(SET_MODAL({type:"usuario-assinante", show:true}))
      }
    }, [effectiveTab, isAssinante, dispatch])

    return <>
        <UserAlert />
        {returnTab(effectiveTab)}
    </>

}

function returnTab(USER_TAB: number) {
    switch (USER_TAB) {
        case 0:
            return <>
                <Autenticar />
                <ContinuarRedesSociais />
            </>
        case 1:
            return <>
                <Cadastrar />
                <ContinuarRedesSociais />
            </>
        case 2:
            return <>
                <Autenticado />
            </>
        case 3:
            return <>
                <Recuperar />
                <ContinuarRedesSociais />
            </>
        default: return <></>
    }
}
